/** 高度による風速の補正（docs/04_world-and-weather.md 9 章）。600m で 0.74、3500m で 1.15 */
export function altitudeWindFactor(altM: number): number {
  return Math.pow(Math.max(altM, 100) / 2000, 0.25);
}
